import { useState, useEffect } from 'react';
import axios from 'axios';
import Layout from '@/components/Layout';
import { Eye, ChevronLeft, Calendar, User } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { resolveImgUrl } from '@/utils/imgUrl';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

export default function BeritaPage() {
  const [berita, setBerita] = useState([]);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/berita`).then(r => setBerita(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);

  const openBerita = async (b) => {
    try {
      const { data } = await axios.get(`${API}/berita/${b.id}`);
      setSelected(data);
    } catch { setSelected(b); }
  };

  return (
    <Layout>
      <div className="min-h-screen bg-gray-50">
        <AnimatePresence mode="wait">
          {selected ? (
            <motion.div key="detail" initial={{ opacity: 0, x: 20 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -20 }}>
              <div className="bg-white border-b border-gray-100">
                <button onClick={() => setSelected(null)} data-testid="berita-back-btn"
                  className="flex items-center gap-2 text-emerald-600 text-sm font-medium px-6 pt-12 pb-4">
                  <ChevronLeft size={18} /> Kembali
                </button>
              </div>
              {selected.foto && (
                <img src={resolveImgUrl(selected.foto)} alt={selected.judul} className="w-full h-52 object-cover" />
              )}
              <div className="px-6 py-5">
                <h1 className="font-playfair text-2xl font-bold text-emerald-950 mb-3">{selected.judul}</h1>
                <div className="flex items-center gap-4 text-xs text-gray-400 mb-4">
                  <div className="flex items-center gap-1.5"><User size={12} /> {selected.penulis}</div>
                  <div className="flex items-center gap-1.5"><Calendar size={12} /> {selected.tanggal}</div>
                  <div className="flex items-center gap-1.5"><Eye size={12} /> {selected.viewer_count} pembaca</div>
                </div>
                <div className="prose prose-sm max-w-none text-gray-700 leading-relaxed whitespace-pre-wrap">
                  {selected.konten}
                </div>
              </div>
            </motion.div>
          ) : (
            <motion.div key="list" initial={{ opacity: 0 }} animate={{ opacity: 1 }}>
              <div className="bg-white border-b border-gray-100 px-6 pt-12 pb-5">
                <h1 className="font-playfair text-2xl font-bold text-emerald-950">BQ News</h1>
                <p className="text-sm text-gray-500 mt-0.5">Berita & Pengumuman Pesantren</p>
              </div>
              <div className="p-6 space-y-4">
                {loading && <div className="text-center py-10 text-gray-400">Memuat...</div>}
                {!loading && berita.length === 0 && (
                  <div className="text-center py-10 text-gray-400">Belum ada berita</div>
                )}
                {berita.map((b, i) => (
                  <motion.button key={b.id} data-testid={`berita-item-${b.id}`}
                    initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.06 }}
                    onClick={() => openBerita(b)}
                    className="w-full text-left bg-white rounded-2xl shadow-card overflow-hidden hover:shadow-emerald transition-all duration-200 hover:-translate-y-0.5">
                    {b.foto && <img src={resolveImgUrl(b.foto)} alt={b.judul} className="w-full h-40 object-cover" />}
                    <div className="p-4">
                      <h3 className="font-semibold text-gray-800 text-sm leading-snug mb-1.5">{b.judul}</h3>
                      {b.ringkasan && <p className="text-xs text-gray-500 line-clamp-2">{b.ringkasan}</p>}
                      <div className="flex items-center justify-between mt-3">
                        <div className="flex items-center gap-3 text-xs text-gray-400">
                          <span className="flex items-center gap-1"><Calendar size={11} />{b.tanggal}</span>
                          <span className="flex items-center gap-1"><User size={11} />{b.penulis}</span>
                        </div>
                        <div className="flex items-center gap-1 text-xs text-emerald-600 bg-emerald-50 px-2 py-1 rounded-full">
                          <Eye size={11} />
                          <span>{b.viewer_count || 0}</span>
                        </div>
                      </div>
                    </div>
                  </motion.button>
                ))}
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </Layout>
  );
}
